/*
 * sr-video-modal.js
 * -----------------
 * Modal lightbox para reproducir videos UGC de sr-testimonials con audio.
 * - Click en [data-sr-tst-modal-trigger] abre modal con src del data-src.
 * - Cierre: botón close, click en backdrop, tecla ESC.
 * - Al cerrar: pause video, clear src (libera bandwidth), restaura scroll.
 * - Cero dependencias. Defer. Un solo modal global por instancia de section.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function getModal() {
    return document.querySelector('[data-sr-tst-modal]');
  }

  function openModal(triggerEl) {
    var modal = getModal();
    if (!modal) return;
    var video = modal.querySelector('[data-sr-tst-modal-video]');
    if (!video) return;
    var src = triggerEl.getAttribute('data-src');
    if (!src) return;
    var poster = triggerEl.getAttribute('data-poster');

    video.pause();
    video.removeAttribute('src');
    while (video.firstChild) video.removeChild(video.firstChild);
    if (poster) video.setAttribute('poster', poster);
    else video.removeAttribute('poster');

    var source = document.createElement('source');
    source.src = src;
    source.type = src.indexOf('.mp4') !== -1 ? 'video/mp4' : '';
    video.appendChild(source);
    video.muted = false;
    video.volume = 1.0;
    video.load();

    modal.hidden = false;
    modal.removeAttribute('aria-hidden');
    document.documentElement.classList.add('sr-tst-modal-open');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        // Autoplay con audio puede ser bloqueado en algunos browsers.
        // Como el video tiene controls, el user puede tap play.
      });
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal || modal.hidden) return;
    var video = modal.querySelector('[data-sr-tst-modal-video]');
    if (video) {
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      while (video.firstChild) video.removeChild(video.firstChild);
      video.load();
    }
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sr-tst-modal-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sr-tst-modal-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }
    if (e.target.closest('[data-sr-tst-modal-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }
    var modal = getModal();
    if (modal && !modal.hidden && e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeModal();
    }
  });
})();
